var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._g(_vm._b({staticClass:"v-app-ad d-inline-flex flex-child-1 grow-shrink-0 mb-4",style:(_vm.styles),attrs:{"rounded":"","width":"100%"}},'v-sheet',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }